<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chap-title2">Israeli Air Force in the 1948 War</h1>
<p class="chap-au">Aaron Morris</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?0ae3a956